const ENTRIES: ReadonlyArray<readonly [string, string]> = [
  ['A', 'Grade A'],
  ['B', 'Grade B'],
  ['C', 'Grade C'],
  ['Y', 'B or C'],
  ['O', 'Approve to Open'],
  ['N', 'Not Approved to Open'],
  ['P', 'Pass'],
  ['F', 'Fail'],
  ['S', 'Permit Suspended'],
  ['R', 'Permit Revoked'],
  ['X', 'Closed by SNHD'],
];

export function GradeLegend() {
  return (
    <div className="mt-4 pt-4 border-t border-gray-200">
      <p className="text-xs font-semibold text-gray-700 uppercase tracking-wide mb-2">
        Grade Codes
      </p>
      <dl className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-4 gap-y-1 text-xs text-gray-600">
        {ENTRIES.map(([code, label]) => (
          <div key={code} className="flex items-baseline gap-2">
            <dt className="font-semibold text-gray-900 w-4">{code}</dt>
            <dd>= {label}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
